// extracted by mini-css-extract-plugin
export default {"container":"oC-z","dimension":"pC-z","dimensionLabels":"qC-z"};